<template>
  <div class="editor-containier px-12 p-8 h-full w-full overflow-y-auto">
    <h3 class="text-center font-normal text-xl">
      {{ editRuleId ? "Update" : "Create New" }} Rule for Auto Notification
    </h3>
    <form class="edyst-form-group" @submit.prevent="handleSubmit">
      <div class="text-right flex justify-between items-center">
        <div class="flex items-center font-bold">
          <span
            class="fadeIn mr-2 font-bold text-left"
            :class="rule.status === 'off' ? 'text-red' : 'text-green'"
            style="width: 135px"
            >Notification
            {{ rule.status === "off" ? "Disabled" : "Enabled" }}</span
          >
          <ToggleButton
            :value="rule.status === 'on' ? true : false"
            @input="
              rule.status === 'on'
                ? (rule.status = 'off')
                : (rule.status = 'on')
            "
          />
        </div>
        <div>
          <button
            class="bg-purple-dark px-8 py-2 rounded-sm text-white mr-4"
            @click.prevent.stop="$emit('close-modal')"
          >
            {{ editRuleId ? "Close" : "Discard" }}
          </button>
          <button class="bg-green px-8 py-2 rounded-sm text-white">
            {{ editRuleId ? "Update" : "Create New" }} Rule
          </button>
        </div>
      </div>
      <div class="section items-center mb-4">
        <div class="heading">Event</div>
        <div class="w-full">
          <select
            v-model="rule.event_type"
            style="width: 20%"
            :disabled="editRuleId"
            :class="{ disabled: editRuleId }"
            @change="handleEventTypeChange"
          >
            <option value="CONTEST">Contest</option>
            <option value="LIVECLASS">Liveclass</option>
            <option value="PAYMENT">Payment</option>
          </select>
        </div>
      </div>
      <div class="section items-center mb-4">
        <div class="heading">Trigger</div>
        <div class="w-full">
          <span
            v-if="rule.event_type === 'PAYMENT'"
            class="fadeIn inline-block trigger-value"
            >On Payment Success</span
          >
          <span v-else class="fadeIn">
            <input
              id="time"
              v-model="rule.trigger_value"
              v-validate="'required|numeric'"
              name="trigger"
              type="number"
              class="time mr-2"
              style="margin-top: 0"
              pattern="[0-9]"
            />
            minute(s) <b>before</b> the
            {{ rule.event_type.toLowerCase() }} start
          </span>
          <small class="err-msg text-red block mt-2">
            {{ veeValidateErrors.first("trigger") }}
          </small>
        </div>
      </div>
      <div class="section items-center mb-4">
        <div class="heading">Available Merge Tags</div>
        <div class="w-full merge-tags-container flex flex-wrap">
          <button
            v-for="item in mergeTags"
            :key="item"
            class="mr-1 rounded-sm px-1 flex justify-center items-center color-secondary font-normal merge-tag"
            title="Click to copy"
            @click.stop.prevent="copyMergeTag(item)"
          >
            {{ item
            }}<i class="material-icons cursor-pointer full-screen-icon ml-1"
              >content_copy</i
            >
          </button>
        </div>
      </div>
      <div class="section">
        <div class="heading mt-4">Channel</div>
        <div class="w-full">
          <div class="channel-item">
            <div class="toggle-btn-container">
              <ToggleButton
                v-model="rule.templates.email.is_active"
                class="mr-2"
              />
              Email
            </div>
            <div
              class="input-container"
              :class="{ disabled: !rule.templates.email.is_active }"
            >
              <label for="email-subject">Email Subject</label>
              <input
                id="email-subject"
                v-model="rule.templates.email.subject"
                :v-validate="rule.templates.email.is_active ? 'required' : ''"
                name="email subject"
                type="text"
                placeholder="Enter email subject"
              />
              <small class="err-msg text-red block mt-2">
                {{ veeValidateErrors.first("email subject") }}
              </small>
              <label for="email-body" class="mt-2 flex justify-between"
                >Email body
                <button
                  class="bg-grey-light rounded-sm flex justify-center items-center p-1"
                  @click.stop.prevent="openFullScreen"
                >
                  <i class="material-icons cursor-pointer full-screen-icon"
                    >open_in_full</i
                  >
                </button>
              </label>
              <div
                ref="emailEditorContainer"
                class="email-body-editor-container bg-white"
              >
                <div
                  id="email-body"
                  ref="myQuillEditor"
                  name="email body"
                  class="email-editor w-full h-1/5"
                  :options="quillEditorOptions"
                ></div>
              </div>
            </div>
          </div>
          <div class="channel-item">
            <div class="toggle-btn-container">
              <ToggleButton
                v-model="rule.templates.whatsapp.is_active"
                class="mr-2"
              />
              WhatsApp
            </div>
            <div
              class="input-container"
              :class="{ disabled: !rule.templates.whatsapp.is_active }"
            >
              <label for="whatsapp-template">Template Name</label>
              <VueSelect
                v-model="rule.templates.whatsapp.template_name"
                :options="whatsAppTemplatesOptions"
                placeholder="Select Template Name"
                class="w-full mt-2"
              />
              <small class="err-msg text-red block mt-2">
                {{ veeValidateErrors.first("template name") }}
              </small>
              <input
                v-model="rule.templates.whatsapp.template_name"
                v-validate="rule.templates.whatsapp.is_active ? 'required' : ''"
                type="hidden"
                name="template name"
              />
            </div>
          </div>
          <div class="channel-item">
            <div class="toggle-btn-container">
              <ToggleButton
                v-model="rule.templates.web_push.is_active"
                class="mr-2"
              />
              Web Push
            </div>
            <div
              class="input-container"
              :class="{ disabled: !rule.templates.web_push.is_active }"
            >
              <label for="push header">Notification Header</label>
              <input
                id="push header"
                v-model="rule.templates.web_push.header"
                v-validate="rule.templates.web_push.is_active ? 'required' : ''"
                type="text"
                name="notification header"
                placeholder="Enter push notification header"
              />
              <small class="err-msg text-red block mt-2">
                {{ veeValidateErrors.first("notification header") }}
              </small>
              <label for="push body" class="mt-2">Notification Body</label>
              <textarea
                id="push body"
                v-model="rule.templates.web_push.body"
                v-validate="rule.templates.web_push.is_active ? 'required' : ''"
                cols="30"
                rows="10"
                placeholder="Enter notification body"
                style="height: 4rem"
                name="notification body"
              ></textarea>
              <small class="err-msg text-red block mt-2">
                {{ veeValidateErrors.first("notification body") }}
              </small>
              <label for="push url" class="mt-2"
                >Notification URL
                <span class="font-normal text-xs"
                  >(Exclude
                  <code class="bg-grey-light px-1 rounded-sm">https://</code> if
                  you're using merge tag to populate the URL)</span
                ></label
              >
              <input
                id="push url"
                v-model="rule.templates.web_push.url"
                v-validate="rule.templates.web_push.is_active ? 'required' : ''"
                type="text"
                name="notification url"
                placeholder="Enter URL to add to push notification"
              />
              <small class="err-msg text-red block mt-2">
                {{ veeValidateErrors.first("notification url") }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div
        class="section items-start mb-4 audience-section"
        :class="{ disabled: rule.event_type === 'PAYMENT' }"
      >
        <div class="heading">Audience</div>
        <div class="w-full">
          <div>
            <label for="audience">Users</label>
            <select
              id="audience"
              v-model="rule.audience.email_in"
              class="w-full block"
              style="width: 15rem"
            >
              <option value="invited">All Invited</option>
              <option value="registered">All Registered</option>
            </select>
          </div>
          <div class="w-full flex items-center mt-2">
            <div class="w-1/2 mr-2">
              <label
                >{{
                  rule.event_type === "LIVECLASS"
                    ? "Liveclass"
                    : rule.event_type === "CONTEST"
                    ? "Contests"
                    : "Events"
                }}
                to exclude</label
              >
              <VueSelect
                v-model="selectedEvents"
                :options="eventOptions"
                :searchable="true"
                :loading="loadingEvents"
                multiple
                :placeholder="
                  rule.event_type === 'LIVECLASS'
                    ? 'Search for live classes'
                    : rule.event_type === 'CONTEST'
                    ? 'Search for Contests'
                    : ''
                "
                label="name"
                class="w-full event-options mt-2"
                @search="handleSearch"
              />
            </div>
            <div class="w-1/2">
              <label>Cohorts to exclude</label>
              <VueSelect
                v-model="selectedCohorts"
                :options="cohortOptions"
                :searchable="true"
                :loading="loadingCohorts"
                multiple
                placeholder="Search for cohorts"
                label="name"
                class="w-full mt-2"
                @search="searchCohorts"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Quill from "quill"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import VueSelect from "vue-select"
import ToggleButton from "@/components/shared/ToggleButton"
import setupImageUpload from "@/utils/quillEditorImageUploadHelper"
import { getContests, getLiveclasses, getCohorts, getEventContests } from "@/apis/events/index"
import {
  createAutoNotification,
  getAutoNotificationDetails,
  updateAutoNotification,
  getWhatsAppTemplates,
} from "@/apis/notification/index"
import copy from "@/utils/copy"

export default {
  components: {
    ToggleButton,
    VueSelect,
  },
  props: {
    editRuleId: {
      type: Number,
    },
  },
  data() {
    return {
      checked: false,
      quillInstance: null,
      selectedEvents: [],
      eventOptions: [],
      loadingEvents: false,
      selectedCohorts: [],
      cohortOptions: [],
      loadingCohorts: false,
      whatsAppTemplatesOptions: [],
      eventMergeTags: [
        "{{FIRSTNAME}}",
        "{{LASTNAME}}",
        "{{EVENT_NAME}}",
        "{{EVENT_STARTS_AT}}",
        "{{EVENT_ENDS_AT}}",
        "{{EVENT_DURATION}}",
        "{{EVENT_LINK}}",
      ],
      paymentMergeTags: [
        "{{FIRSTNAME}}",
        "{{LASTNAME}}",
        "{{AMOUNT_PAID}}",
        "{{INVOICE_NUMBER}}",
        "{{PURCHASE_DATE}}",
        "{{DISCOUNT_APPLIED}}",
        "{{COHORT_NAME}}",
      ],
      rule: {
        event_type: "LIVECLASS",
        status: "on",
        trigger_type: "BEFORE",
        trigger_value: 5,
        audience: {
          email_in: "registered",
          exclude_events: [],
          exclude_cohorts: [],
        },
        templates: {
          email: {
            is_active: true,
            subject: "",
            body: "",
          },
          web_push: {
            is_active: true,
            header: "",
            body: "",
            url: "",
          },
          whatsapp: {
            is_active: true,
            template_name: "",
          },
        },
      },
      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
          ],
        },
        placeholder: "Start designing your email...",
        readOnly: false,
        theme: "snow",
      },
    }
  },
  computed: {
    mergeTags() {
      return this.rule.event_type === "PAYMENT"
        ? this.paymentMergeTags
        : this.eventMergeTags
    },
  },
  created() {
    if (this.editRuleId) {
      this.fetchRuleDetails()
    }
    this.fetchWhatsAppTemplates()
    setupImageUpload(this.quillEditorOptions)
  },
  mounted() {
    this.quillInstance = new Quill(
      this.$refs.myQuillEditor,
      this.quillEditorOptions
    )

    this.quillInstance.on("text-change", () => {
      this.rule.templates.email.body = this.quillInstance.root.innerHTML
    })
  },
  methods: {
    copyMergeTag(tag) {
      copy(tag)
      this.$noty.info("Copied", { timeout: 1000 })
    },
    openFullScreen() {
      this.$refs.emailEditorContainer.requestFullscreen()
    },
    handleEventTypeChange(evt) {
      if (evt.target.value === "PAYMENT") {
        this.rule.trigger_type = "ON_SUCCESS"
        this.rule.trigger_value = 0
        this.rule.audience.email_in = ""
        this.selectedEvents = []
        // clean invited and selected cohorts
      } else {
        /* for contest and liveclass */
        this.rule.trigger_type = "BEFORE"
        this.rule.audience.email_in = "registered"
      }
    },
    async handleSearch(query) {
      this.loadingEvents = true
      let res
      if (this.rule.event_type === "LIVECLASS") {
        res = await getLiveclasses(query)
      } else if (this.rule.event_type === "CONTEST") {
        res = await getEventContests(query)
      }
      this.loadingEvents = false
      if (res && res.data) {
        this.eventOptions = res.data.items.map(item => ({
          ...item,
          name: item.event_name ? item.event_name : item.name,
        }))
      }
    },
    async searchCohorts(query) {
      try {
        const res = await getCohorts(query)
        this.cohortOptions = res.data.items.map(item => ({
          name: item.name,
          id: item.id,
        }))
      } catch (err) {
        console.error(err)
        this.$noty.error("Failed to fetch cohorts")
      }
    },
    fetchRuleDetails() {
      getAutoNotificationDetails(this.editRuleId)
        .then(res => {
          this.rule = res.data.notification
          this.quillInstance.root.innerHTML =
            res.data.notification.templates.email.body
          if (res.data.notification.audience.exclude_events.length > 0) {
            this.populateEventsByIds(res.data.notification)
          }
          if (
            res.data.notification.audience.exclude_cohorts &&
            res.data.notification.audience.exclude_cohorts.length > 0
          ) {
            this.populateCohortsByIds(
              res.data.notification.audience.exclude_cohorts
            )
          }
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to get auto notification details")
        })
    },
    async populateCohortsByIds(ids) {
      try {
        const res = await getCohorts()
        const arr = []
        ids.forEach(id => {
          const cohort = res.data.items.find(c => c.id === id)
          if (cohort) {
            arr.push(cohort)
          }
        })
        this.selectedCohorts = arr
      } catch (err) {
        console.error(err)
        this.$noty.error("Failed to populate cohorts")
      }
    },
    async populateEventsByIds(rule) {
      let res
      try {
        if (rule.event_type === "LIVECLASS") {
          res = await getLiveclasses()
        } else if (rule.event_type === "CONTEST") {
          res = await getEventContests()
        }
        /* prepare event list from ids */
        const list = []
        rule.audience.exclude_events.forEach(id => {
          const event = res.data.items.find(item => item.id === id)
          if (event) {
            list.push(event)
          }
        })
        this.selectedEvents = list.map(item => ({
          ...item,
          name: item.event_name ? item.event_name : item.name,
        }))
      } catch (error) {
        console.error(error)
        this.$noty.error("Failed to populate event list")
      }
    },
    async handleSubmit() {
      const v = await this.$validator.validateAll()
      if (!v) {
        this.$noty.error("Please fix the errors and try again")
        return
      }
      /* only check if the notification is enabled */
      if (this.rule.status === "on") {
        /* do not allow save without enabling at least one channel */
        const result = Object.keys(this.rule.templates).some(
          key => this.rule.templates[key].is_active
        )
        if (!result) {
          this.$noty.error("Please select at least one channel for this rule.")
          return
        }
      }

      if (this.rule.templates.email.is_active) {
        // check if email body has valid text
        const div = document.createElement("div")
        div.innerHTML = this.rule.templates.email.body
        if (div.textContent.length === 0) {
          this.$noty.error(
            "Looks like email body doesn't have any content, please add proper content and try again"
          )
          return
        }
      }

      const payload = { ...this.rule }
      if (this.selectedEvents.length > 0) {
        payload.audience.exclude_events = this.selectedEvents.map(
          item => item.id
        )
      }
      if (this.selectedCohorts.length > 0) {
        payload.audience.exclude_cohorts = this.selectedCohorts.map(
          item => item.id
        )
      }
      if (this.editRuleId) {
        this.updateRule(payload)
      } else {
        this.createRule(payload)
      }
    },
    createRule(payload) {
      createAutoNotification(payload)
        .then(res => {
          this.$noty.info(res.data.message)
          this.$emit("notification-created")
        })
        .catch(err => {
          console.error(err)
          let msg = ""
          if (err.response) {
            msg = err.response.data.message
          }
          this.$noty.error(`Failed to create auto notification: ${msg}`)
        })
    },
    updateRule(payload) {
      updateAutoNotification(this.editRuleId, payload)
        .then(res => {
          this.$noty.info(res.data.message)
          this.$emit("notification-created")
        })
        .catch(err => {
          console.error(err)
          let msg = ""
          if (err.response) {
            msg = err.response.data.message
          }
          this.$noty.error(`Failed to update auto notification: ${msg}`)
        })
    },
    fetchWhatsAppTemplates() {
      getWhatsAppTemplates()
        .then(res => {
          this.whatsAppTemplatesOptions = res.data.templates
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to WhatsApp templates.`)
        })
    },
  },
}
</script>

<style scoped lang="scss">
.editor-containier {
  @apply pt-8 m-auto;
  max-width: 1400px;
  font-size: 0.9rem;
}

.heading {
  @apply font-bold pr-4;
  width: 10rem;
}

.section {
  @apply flex;
}

.section label {
  @apply text-sm;
  color: #424242;
  font-weight: bold;
}

.channel-item {
  @apply flex my-3 items-start mb-4;
}

.input-container {
  @apply flex flex-col w-full;
  max-height: 300px;
  transition: all 0.3s ease-out;
}

.toggle-btn-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 11rem;
}

.audience-section {
  transition: all 0.3s ease-out;
}

.audience-section select {
  margin-top: 0;
}

.time {
  max-width: 4rem;
}

.email-editor {
  overflow: auto;
  max-height: 80vh;
}

.full-screen-icon {
  font-size: 0.9rem;
}

.disabled {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  cursor: not-allowed;
  user-select: none;
  transition: all 0.3s ease-out;
  pointer-events: none;
}

.trigger-value {
  height: 35px;
  line-height: 35px;
}

.merge-tags-container {
  @apply text-left text-sm;

  padding: 1rem 0.8rem;
  border-left: 4px solid #58b4ff;
  font-family: monospace;
}

.merge-tag {
  margin: 0.1rem 0.5rem 0.35rem 0;
  padding: 0.1rem 0.25rem;
  border: 1px solid #3fd33f;
  background: #efffef;
}

.merge-tag:hover,
.merge-tag:active,
.merge-tag:focus {
  color: #353535;
  background: #c7f1c7;
}
</style>
